export interface CountriesState {
  countries: CountryDetails[];
  selectedCountry: string;
  error?: any;
}

export interface CountriesRequest {
  country: string;
  userLanguage: string;
}

export interface States {
  code: string;
  name: string;
}

export interface CountryDetails {
  active?: boolean;
  baseCurrency?: string;
  indicativeRateActive?: boolean;
  iso2Code: string;
  iso3Code: string;
  code?: string;
  name: string;
  phoneDialCodes?: string[];
  receiveActive?: boolean;
  receiveCurrencies?: string[];
  sendActive?: boolean;
  sendCurrencies?: string[];
  states: States[];
}
export interface CountriesResponse {
  countries: CountryDetails[];
  selectedCountry: string;
}
